"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HMACTokenBuilder = void 0;
// @ts-ignore
var CryptoJS = __importStar(require("crypto-js"));
var __1 = require("..");
var GaiaCredentials_1 = require("../api/GaiaCredentials");
var HttpClient_1 = require("./HttpClient");
var HMACTokenBuilder = /** @class */ (function () {
    function HMACTokenBuilder() {
        this.payload = "";
        this.nonce = "";
        this.timestamp = 0;
        this.clientOptions = new __1.ClientOptions(new GaiaCredentials_1.HMACCredentials("", ""), "application/json");
    }
    HMACTokenBuilder.prototype.withPayload = function (payload) {
        this.payload = payload;
        return this;
    };
    HMACTokenBuilder.prototype.withNonce = function (nonce) {
        this.nonce = nonce;
        return this;
    };
    HMACTokenBuilder.prototype.withClientOptions = function (clientOptions) {
        this.clientOptions = clientOptions;
        return this;
    };
    HMACTokenBuilder.prototype.withTimestamp = function (timestamp) {
        this.timestamp = timestamp;
        return this;
    };
    /**
     * Authorization: "HMAC-SHA512 " + API_KEY + "_" +
     * base64(hmac-sha512( content, content_type, sensor_type, timestamp, nonce )) + "_" + timestamp + "_" + nonce
     */
    HMACTokenBuilder.prototype.build = function () {
        return __awaiter(this, void 0, void 0, function () {
            var credentials, sep, HTTP_SENSOR_TYPE, base64EncodedPayload, prepareToHash, hmac, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        credentials = this.clientOptions.credentials;
                        sep = "_";
                        HTTP_SENSOR_TYPE = "http";
                        return [4 /*yield*/, this.toBase64(this.payload)];
                    case 1:
                        base64EncodedPayload = _a.sent();
                        prepareToHash = [base64EncodedPayload, this.clientOptions.contentType, HTTP_SENSOR_TYPE, this.timestamp, this.nonce].join(sep);
                        hmac = CryptoJS.HmacSHA512(Buffer.from(prepareToHash).toString(), credentials.apiSecret).toString();
                        return [4 /*yield*/, this.toBase64(hmac)];
                    case 2:
                        signature = _a.sent();
                        return [2 /*return*/, "HMAC-SHA512 " + [credentials.apiKey, signature, this.timestamp, this.nonce].join(sep)];
                }
            });
        });
    };
    HMACTokenBuilder.prototype.toBase64 = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var arrBuff, stringData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isBuffer(data)) return [3 /*break*/, 1];
                        // Node
                        return [2 /*return*/, data.toString('base64')];
                    case 1:
                        if (!this.isBrowserBlob(data)) return [3 /*break*/, 3];
                        return [4 /*yield*/, data.arrayBuffer()];
                    case 2:
                        arrBuff = _a.sent();
                        return [2 /*return*/, new Buffer(arrBuff).toString('base64')];
                    case 3:
                        stringData = HttpClient_1.HttpClient.asString(data);
                        return [2 /*return*/, typeof btoa !== 'undefined' && this.b64EncodeUnicode(stringData) || Buffer.from(this.encodeWithFixedSpecialChars(stringData), 'binary').toString('base64')];
                }
            });
        });
    };
    // see https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
    HMACTokenBuilder.prototype.b64EncodeUnicode = function (str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(this.encodeWithFixedSpecialChars(str));
    };
    HMACTokenBuilder.prototype.encodeWithFixedSpecialChars = function (str) {
        return encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
            return String.fromCharCode(Number('0x' + p1));
        });
    };
    HMACTokenBuilder.prototype.isBuffer = function (b) {
        return !!b.writeFloatLE;
    };
    HMACTokenBuilder.prototype.isBrowserBlob = function (blob) {
        return typeof (blob) === 'object' && blob.toString() === '[object Blob]';
    };
    return HMACTokenBuilder;
}());
exports.HMACTokenBuilder = HMACTokenBuilder;
//# sourceMappingURL=HMACTokenBuilder.js.map